package team.platforma.aicombo.utils

import androidx.compose.runtime.Composable

expect class ClipboardAPI() {
    @Composable
    fun available(): Boolean
    suspend fun pasteFromClipboard(): String
}

val CLIPBOARD get() = ClipboardAPI()